var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _circle, _circle2, _circle3, _circle4, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _circle5, _circle6, _circle7, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _g, _g2, _path200, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 198,
    viewBox: "0 0 386 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10322_10129)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_10129)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "#601F93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.613 140.627C118.736 144.733 119.31 197.882 113 228.046V256.682L477.807 271L484.116 64.2459C496.162 1.24598 381.824 -33.0113 338.423 7.54598C293.683 49.355 301.139 135.472 199.613 140.627Z",
    fill: "#6A48B3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.474 168.878H259.648V190.532H278.474V168.878Z",
    fill: "#463332"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.474 173.428H259.648V180.21H278.474V173.428Z",
    fill: "#463332"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.702 67.207H203.42C199.493 67.207 196.31 70.3844 196.31 74.3038V166.149C196.31 170.068 199.493 173.246 203.42 173.246H334.702C338.628 173.246 341.811 170.068 341.811 166.149V74.3038C341.811 70.3844 338.628 67.207 334.702 67.207Z",
    fill: "url(#paint0_linear_10322_10129)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.31 160.425V166.43C196.31 170.532 199.492 173.874 203.42 173.874H334.702C338.629 173.874 341.811 170.549 341.811 166.43V160.425H196.31Z",
    fill: "url(#paint1_linear_10322_10129)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M332.034 69.374H206.104C202.343 69.374 199.293 72.4181 199.293 76.1731V149.656C199.293 153.411 202.343 156.455 206.104 156.455H332.034C335.795 156.455 338.845 153.411 338.845 149.656V76.1731C338.845 72.4181 335.795 69.374 332.034 69.374Z",
    fill: "url(#paint2_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.127 73.2945C331.934 72.0372 330.244 71.2432 328.371 71.2432H207.679C204.066 71.2432 201.149 74.1547 201.149 77.761V148.2C201.149 149.689 201.647 151.078 202.508 152.17L333.127 73.2945Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.622 187.423H291.499C293.355 187.423 294.863 188.928 294.863 190.781V195.512H243.242V190.781C243.242 188.928 244.75 187.423 246.606 187.423H246.622Z",
    fill: "url(#paint3_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.499 187.423H269.243C271.099 187.423 272.607 188.928 272.607 190.781V195.512H294.863V190.781C294.863 188.928 293.355 187.423 291.499 187.423Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.764 189.64C259.764 190.748 253.665 190.98 249.307 190.98C245.446 190.98 244.833 190.384 244.833 189.64C244.833 188.895 245.711 188.3 249.307 188.3C253.665 188.3 259.764 188.548 259.764 189.64Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.437 189.64C264.437 190.087 263.575 190.401 262.631 190.401C261.686 190.401 261.023 190.053 261.023 189.64C261.023 189.226 261.686 188.879 262.631 188.879C263.575 188.879 264.437 189.193 264.437 189.64Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.88 194.023H243.258V195.512H294.88V194.023Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.811 160.425H196.31V162.36H341.811V160.425Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M333.393 167.456C333.393 168.978 332.15 170.219 330.625 170.219C329.1 170.219 327.858 168.978 327.858 167.456C327.858 165.934 329.1 164.693 330.625 164.693C332.15 164.693 333.393 165.934 333.393 167.456Z",
    fill: "#463332"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M332.465 167.456C332.465 168.466 331.653 169.276 330.642 169.276C329.631 169.276 328.819 168.466 328.819 167.456C328.819 166.447 329.631 165.637 330.642 165.637C331.653 165.637 332.465 166.447 332.465 167.456Z",
    fill: "url(#paint4_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M332.654 75.9609H275V152.967H332.654V75.9609Z",
    fill: "#6D4791"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.654 73H275V150.006H332.654V73Z",
    fill: "#FFF4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M328.792 76.4082H278.828V83.8359H328.792V76.4082Z",
    fill: "url(#paint5_linear_10322_10129)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289 82.5091V78.076H289.532V82.0847H291.597V82.5091H289Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M292.327 82.5091V78.076H295.069V78.513H292.859V80.0582H294.879V80.4888H292.859V82.0721H295.069V82.5091H292.327Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M297.314 82.5851C296.989 82.5851 296.706 82.5259 296.466 82.4077C296.225 82.2895 296.039 82.1249 295.908 81.9138C295.777 81.7027 295.712 81.4578 295.712 81.1791H296.269C296.269 81.3522 296.309 81.5127 296.39 81.6604C296.47 81.804 296.586 81.9201 296.738 82.0088C296.894 82.0932 297.086 82.1354 297.314 82.1354C297.614 82.1354 297.846 82.0636 298.011 81.9201C298.175 81.7765 298.258 81.5971 298.258 81.3818C298.258 81.2045 298.22 81.063 298.144 80.9575C298.068 80.8477 297.964 80.7591 297.833 80.6915C297.707 80.624 297.559 80.5648 297.39 80.5142C297.226 80.4635 297.052 80.4065 296.871 80.3432C296.529 80.225 296.276 80.0793 296.111 79.9062C295.946 79.7289 295.864 79.4988 295.864 79.2159C295.86 78.9795 295.915 78.7705 296.029 78.589C296.143 78.4032 296.303 78.2597 296.51 78.1583C296.721 78.0528 296.97 78 297.257 78C297.54 78 297.785 78.0528 297.992 78.1583C298.203 78.2639 298.365 78.4095 298.479 78.5953C298.598 78.7811 298.659 78.9922 298.663 79.2286H298.106C298.106 79.1062 298.074 78.9858 298.011 78.8676C297.947 78.7452 297.85 78.646 297.719 78.57C297.593 78.494 297.432 78.456 297.238 78.456C296.998 78.4518 296.799 78.513 296.643 78.6396C296.491 78.7663 296.415 78.9415 296.415 79.1653C296.415 79.3553 296.468 79.5009 296.573 79.6022C296.683 79.7036 296.835 79.788 297.029 79.8556C297.223 79.9189 297.447 79.9928 297.7 80.0772C297.912 80.1532 298.102 80.2419 298.27 80.3432C298.439 80.4445 298.57 80.5754 298.663 80.7358C298.76 80.8963 298.809 81.101 298.809 81.3501C298.809 81.5612 298.754 81.7618 298.644 81.9518C298.534 82.1375 298.368 82.2895 298.144 82.4077C297.924 82.5259 297.648 82.5851 297.314 82.5851Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M300.975 82.5851C300.65 82.5851 300.367 82.5259 300.127 82.4077C299.886 82.2895 299.7 82.1249 299.569 81.9138C299.439 81.7027 299.373 81.4578 299.373 81.1791H299.93C299.93 81.3522 299.971 81.5127 300.051 81.6604C300.131 81.804 300.247 81.9201 300.399 82.0088C300.555 82.0932 300.747 82.1354 300.975 82.1354C301.275 82.1354 301.507 82.0636 301.672 81.9201C301.837 81.7765 301.919 81.5971 301.919 81.3818C301.919 81.2045 301.881 81.063 301.805 80.9575C301.729 80.8477 301.626 80.7591 301.495 80.6915C301.368 80.624 301.22 80.5648 301.051 80.5142C300.887 80.4635 300.714 80.4065 300.532 80.3432C300.19 80.225 299.937 80.0793 299.772 79.9062C299.607 79.7289 299.525 79.4988 299.525 79.2159C299.521 78.9795 299.576 78.7705 299.69 78.589C299.804 78.4032 299.964 78.2597 300.171 78.1583C300.382 78.0528 300.631 78 300.918 78C301.201 78 301.446 78.0528 301.653 78.1583C301.864 78.2639 302.027 78.4095 302.141 78.5953C302.259 78.7811 302.32 78.9922 302.324 79.2286H301.767C301.767 79.1062 301.735 78.9858 301.672 78.8676C301.609 78.7452 301.512 78.646 301.381 78.57C301.254 78.494 301.094 78.456 300.899 78.456C300.659 78.4518 300.46 78.513 300.304 78.6396C300.152 78.7663 300.076 78.9415 300.076 79.1653C300.076 79.3553 300.129 79.5009 300.234 79.6022C300.344 79.7036 300.496 79.788 300.69 79.8556C300.885 79.9189 301.108 79.9928 301.362 80.0772C301.573 80.1532 301.763 80.2419 301.932 80.3432C302.101 80.4445 302.231 80.5754 302.324 80.7358C302.421 80.8963 302.47 81.101 302.47 81.3501C302.47 81.5612 302.415 81.7618 302.305 81.9518C302.196 82.1375 302.029 82.2895 301.805 82.4077C301.585 82.5259 301.309 82.5851 300.975 82.5851Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.238 82.5851C304.803 82.5851 304.421 82.4901 304.092 82.3001C303.767 82.1059 303.511 81.8357 303.326 81.4895C303.144 81.1433 303.053 80.7443 303.053 80.2925C303.053 79.8408 303.144 79.4439 303.326 79.1019C303.511 78.7557 303.767 78.4855 304.092 78.2913C304.421 78.0971 304.803 78 305.238 78C305.677 78 306.059 78.0971 306.385 78.2913C306.714 78.4855 306.969 78.7557 307.151 79.1019C307.332 79.4439 307.423 79.8408 307.423 80.2925C307.423 80.7443 307.332 81.1433 307.151 81.4895C306.969 81.8357 306.714 82.1059 306.385 82.3001C306.059 82.4901 305.677 82.5851 305.238 82.5851ZM305.238 82.1164C305.563 82.1164 305.848 82.0446 306.093 81.9011C306.342 81.7533 306.534 81.5443 306.67 81.2741C306.809 80.9997 306.878 80.6725 306.878 80.2925C306.878 79.9125 306.809 79.5875 306.67 79.3173C306.534 79.047 306.342 78.8402 306.093 78.6966C305.848 78.5489 305.563 78.475 305.238 78.475C304.913 78.475 304.626 78.5489 304.377 78.6966C304.132 78.8402 303.94 79.047 303.801 79.3173C303.666 79.5875 303.598 79.9125 303.598 80.2925C303.598 80.6725 303.666 80.9997 303.801 81.2741C303.94 81.5443 304.132 81.7533 304.377 81.9011C304.626 82.0446 304.913 82.1164 305.238 82.1164Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M308.191 82.5091V78.076H308.723L311.085 81.6288V78.076H311.617V82.5091H311.085L308.723 78.9563V82.5091H308.191Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M314.67 82.5091V78.6713L313.954 78.8296V78.4623L314.847 78.076H315.208V82.5091H314.67Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M316.074 82.5091V82.1354C316.374 81.899 316.657 81.6604 316.923 81.4198C317.193 81.1749 317.432 80.9343 317.638 80.6978C317.85 80.4614 318.014 80.2292 318.132 80.0012C318.255 79.7732 318.316 79.5537 318.316 79.3426C318.316 79.1864 318.289 79.0407 318.234 78.9056C318.183 78.7705 318.099 78.6628 317.98 78.5826C317.862 78.4982 317.702 78.456 317.499 78.456C317.305 78.456 317.142 78.5003 317.011 78.589C316.881 78.6734 316.781 78.7874 316.714 78.9309C316.65 79.0745 316.619 79.2286 316.619 79.3932H316.106C316.106 79.1019 316.167 78.8528 316.29 78.646C316.412 78.4349 316.579 78.2744 316.79 78.1647C317.001 78.0549 317.239 78 317.505 78C317.898 78 318.219 78.1119 318.468 78.3356C318.721 78.5552 318.848 78.8845 318.848 79.3236C318.848 79.5853 318.783 79.845 318.652 80.1025C318.521 80.3559 318.354 80.6028 318.151 80.8435C317.949 81.0799 317.731 81.3016 317.499 81.5085C317.271 81.7153 317.058 81.9011 316.859 82.0658H319V82.5091H316.074Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 89.1298L300.734 88H289L289.013 89.1298H300.747Z",
    fill: "#DDC8BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M328 89.1298L327.974 88H302.113L302.139 89.1298H328Z",
    fill: "#DDC8BA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 94.4413L300.734 93.3115H289L289.013 94.4413H300.747Z",
    fill: "#DDC8BA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M328 94.4413L327.974 93.3115H302.113L302.139 94.4413H328Z",
    fill: "#DDC8BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M328 91.7792V90.6494H314.536L314.562 91.7792H328Z",
    fill: "#DDC8BA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.378 91.7792V90.6494H289L289.026 91.7792H313.378Z",
    fill: "#DDC8BA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.713 97.1161L295.699 95.9863H289L289.013 97.1161H295.713Z",
    fill: "#DDC8BA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M312.78 97.0643L312.754 95.9346H297.091L297.104 97.0643H312.78Z",
    fill: "#DDC8BA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 102.13L300.734 101H289L289.013 102.13H300.747Z",
    fill: "#DDC8BA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M328 102.13L327.974 101H302.113L302.139 102.13H328Z",
    fill: "#DDC8BA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 107.441L300.734 106.312H289L289.013 107.441H300.747Z",
    fill: "#DDC8BA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M328 107.441L327.974 106.312H302.113L302.139 107.441H328Z",
    fill: "#DDC8BA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M328 104.779V103.649H314.536L314.562 104.779H328Z",
    fill: "#DDC8BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M313.378 104.779V103.649H289L289.026 104.779H313.378Z",
    fill: "#DDC8BA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M295.713 110.116L295.699 108.986H289L289.013 110.116H295.713Z",
    fill: "#DDC8BA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M312.78 110.064L312.754 108.935H297.091L297.104 110.064H312.78Z",
    fill: "#DDC8BA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 115.13L300.734 114H289L289.013 115.13H300.747Z",
    fill: "#DDC8BA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M328 115.13L327.974 114H302.113L302.139 115.13H328Z",
    fill: "#DDC8BA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 120.441L300.734 119.312H289L289.013 120.441H300.747Z",
    fill: "#DDC8BA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M328 120.441L327.974 119.312H302.113L302.139 120.441H328Z",
    fill: "#DDC8BA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M328 117.779V116.649H314.536L314.562 117.779H328Z",
    fill: "#DDC8BA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M313.378 117.779V116.649H289L289.026 117.779H313.378Z",
    fill: "#DDC8BA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M295.713 123.116L295.699 121.986H289L289.013 123.116H295.713Z",
    fill: "#DDC8BA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M312.78 123.064L312.754 121.935H297.091L297.104 123.064H312.78Z",
    fill: "#DDC8BA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 128.13L300.734 127H289L289.013 128.13H300.747Z",
    fill: "#DDC8BA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M328 128.13L327.974 127H302.113L302.139 128.13H328Z",
    fill: "#DDC8BA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 133.441L300.734 132.312H289L289.013 133.441H300.747Z",
    fill: "#DDC8BA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M328 133.441L327.974 132.312H302.113L302.139 133.441H328Z",
    fill: "#DDC8BA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M328 130.779V129.649H314.536L314.562 130.779H328Z",
    fill: "#DDC8BA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M313.378 130.779V129.649H289L289.026 130.779H313.378Z",
    fill: "#DDC8BA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M295.713 136.116L295.699 134.986H289L289.013 136.116H295.713Z",
    fill: "#DDC8BA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M312.78 136.064L312.754 134.935H297.091L297.104 136.064H312.78Z",
    fill: "#DDC8BA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 139.13L300.734 138H289L289.013 139.13H300.747Z",
    fill: "#DDC8BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M328 139.13L327.974 138H302.113L302.139 139.13H328Z",
    fill: "#DDC8BA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M300.747 144.441L300.734 143.312H289L289.013 144.441H300.747Z",
    fill: "#DDC8BA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M328 144.441L327.974 143.312H302.113L302.139 144.441H328Z",
    fill: "#DDC8BA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M328 141.779V140.649H314.536L314.562 141.779H328Z",
    fill: "#DDC8BA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M313.378 141.779V140.649H289L289.026 141.779H313.378Z",
    fill: "#DDC8BA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 91,
    r: 3,
    fill: "url(#paint6_linear_10322_10129)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 104,
    r: 3,
    fill: "url(#paint7_linear_10322_10129)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 117,
    r: 3,
    fill: "url(#paint8_linear_10322_10129)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 130,
    r: 3,
    fill: "url(#paint9_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M267.653 76.3545H210V153.361H267.653V76.3545Z",
    fill: "#6D4791"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M267.653 73.3936H210V150.4H267.653V73.3936Z",
    fill: "#FFF4EE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 89.1298L235.734 88H224L224.013 89.1298H235.747Z",
    fill: "#DDC8BA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M263 89.1298L262.974 88H237.113L237.139 89.1298H263Z",
    fill: "#DDC8BA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 94.4413L235.734 93.3115H224L224.013 94.4413H235.747Z",
    fill: "#DDC8BA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M263 94.4413L262.974 93.3115H237.113L237.139 94.4413H263Z",
    fill: "#DDC8BA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M263 91.7792V90.6494H249.536L249.562 91.7792H263Z",
    fill: "#DDC8BA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M248.378 91.7792V90.6494H224L224.026 91.7792H248.378Z",
    fill: "#DDC8BA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M230.712 97.1161L230.699 95.9863H224L224.013 97.1161H230.712Z",
    fill: "#DDC8BA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M247.78 97.0643L247.754 95.9346H232.091L232.104 97.0643H247.78Z",
    fill: "#DDC8BA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 102.13L235.734 101H224L224.013 102.13H235.747Z",
    fill: "#DDC8BA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M263 102.13L262.974 101H237.113L237.139 102.13H263Z",
    fill: "#DDC8BA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 107.441L235.734 106.312H224L224.013 107.441H235.747Z",
    fill: "#DDC8BA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M263 107.441L262.974 106.312H237.113L237.139 107.441H263Z",
    fill: "#DDC8BA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M263 104.779V103.649H249.536L249.562 104.779H263Z",
    fill: "#DDC8BA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M248.378 104.779V103.649H224L224.026 104.779H248.378Z",
    fill: "#DDC8BA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M230.712 110.116L230.699 108.986H224L224.013 110.116H230.712Z",
    fill: "#DDC8BA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M247.78 110.064L247.754 108.935H232.091L232.104 110.064H247.78Z",
    fill: "#DDC8BA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 115.13L235.734 114H224L224.013 115.13H235.747Z",
    fill: "#DDC8BA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M263 115.13L262.974 114H237.113L237.139 115.13H263Z",
    fill: "#DDC8BA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M235.747 120.441L235.734 119.312H224L224.013 120.441H235.747Z",
    fill: "#DDC8BA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M263 120.441L262.974 119.312H237.113L237.139 120.441H263Z",
    fill: "#DDC8BA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M263 117.779V116.649H249.536L249.562 117.779H263Z",
    fill: "#DDC8BA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M248.378 117.779V116.649H224L224.026 117.779H248.378Z",
    fill: "#DDC8BA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M230.712 123.116L230.699 121.986H224L224.013 123.116H230.712Z",
    fill: "#DDC8BA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M247.78 123.064L247.754 121.935H232.091L232.104 123.064H247.78Z",
    fill: "#DDC8BA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M228.964 130.533L228.948 129.094H214L214.017 130.533H228.964Z",
    fill: "#DDC8BA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M263.682 130.533L263.649 129.094H230.704L230.738 130.533H263.682Z",
    fill: "#DDC8BA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M263.682 127.439V126H246.531L246.564 127.439H263.682Z",
    fill: "#DDC8BA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M245.056 127.439V126H214L214.033 127.439H245.056Z",
    fill: "#DDC8BA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M222.551 133.66L222.534 132.221H214L214.017 133.66H222.551Z",
    fill: "#DDC8BA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M244.293 133.594L244.26 132.154H224.308L224.324 133.594H244.293Z",
    fill: "#DDC8BA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M263.792 76.8018H213.828V84.2294H263.792V76.8018Z",
    fill: "url(#paint10_linear_10322_10129)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M224 82.9171V78.0829H224.568V82.4544H226.77V82.9171H224Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M227.55 82.9171V78.0829H230.475V78.5594H228.117V80.2445H230.273V80.7141H228.117V82.4406H230.475V82.9171H227.55Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M232.87 83C232.523 83 232.222 82.9355 231.965 82.8066C231.708 82.6777 231.51 82.4982 231.37 82.268C231.231 82.0378 231.161 81.7707 231.161 81.4669H231.755C231.755 81.6556 231.798 81.8306 231.884 81.9917C231.969 82.1483 232.093 82.2749 232.255 82.3715C232.422 82.4636 232.627 82.5097 232.87 82.5097C233.19 82.5097 233.438 82.4314 233.614 82.2749C233.789 82.1183 233.877 81.9227 233.877 81.6878C233.877 81.4945 233.836 81.3402 233.755 81.2251C233.674 81.1054 233.564 81.0087 233.424 80.9351C233.289 80.8614 233.132 80.797 232.951 80.7417C232.776 80.6865 232.591 80.6243 232.397 80.5552C232.032 80.4263 231.762 80.2675 231.587 80.0787C231.411 79.8854 231.323 79.6344 231.323 79.326C231.319 79.0681 231.377 78.8402 231.499 78.6423C231.62 78.4397 231.792 78.2831 232.012 78.1727C232.237 78.0576 232.503 78 232.809 78C233.111 78 233.373 78.0576 233.593 78.1727C233.818 78.2878 233.992 78.4466 234.114 78.6492C234.24 78.8517 234.305 79.082 234.309 79.3398H233.715C233.715 79.2063 233.681 79.075 233.614 78.9461C233.546 78.8126 233.442 78.7044 233.303 78.6215C233.168 78.5387 232.996 78.4972 232.789 78.4972C232.532 78.4926 232.321 78.5594 232.154 78.6975C231.992 78.8356 231.911 79.0267 231.911 79.2707C231.911 79.4779 231.967 79.6367 232.08 79.7472C232.197 79.8577 232.359 79.9498 232.566 80.0235C232.773 80.0925 233.012 80.1731 233.282 80.2652C233.508 80.3481 233.71 80.4448 233.891 80.5552C234.071 80.6657 234.21 80.8085 234.309 80.9834C234.413 81.1584 234.465 81.3817 234.465 81.6533C234.465 81.8835 234.406 82.1022 234.289 82.3094C234.172 82.512 233.994 82.6777 233.755 82.8066C233.521 82.9355 233.226 83 232.87 83Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M236.776 83C236.43 83 236.128 82.9355 235.871 82.8066C235.614 82.6777 235.416 82.4982 235.276 82.268C235.137 82.0378 235.067 81.7707 235.067 81.4669H235.662C235.662 81.6556 235.704 81.8306 235.79 81.9917C235.876 82.1483 235.999 82.2749 236.162 82.3715C236.328 82.4636 236.533 82.5097 236.776 82.5097C237.096 82.5097 237.344 82.4314 237.52 82.2749C237.695 82.1183 237.783 81.9227 237.783 81.6878C237.783 81.4945 237.743 81.3402 237.662 81.2251C237.58 81.1054 237.47 81.0087 237.33 80.9351C237.195 80.8614 237.038 80.797 236.858 80.7417C236.682 80.6865 236.497 80.6243 236.303 80.5552C235.939 80.4263 235.668 80.2675 235.493 80.0787C235.317 79.8854 235.229 79.6344 235.229 79.326C235.225 79.0681 235.283 78.8402 235.405 78.6423C235.526 78.4397 235.698 78.2831 235.918 78.1727C236.144 78.0576 236.409 78 236.716 78C237.017 78 237.279 78.0576 237.499 78.1727C237.725 78.2878 237.898 78.4466 238.02 78.6492C238.146 78.8517 238.211 79.082 238.216 79.3398H237.621C237.621 79.2063 237.587 79.075 237.52 78.9461C237.452 78.8126 237.348 78.7044 237.209 78.6215C237.074 78.5387 236.903 78.4972 236.695 78.4972C236.439 78.4926 236.227 78.5594 236.06 78.6975C235.898 78.8356 235.817 79.0267 235.817 79.2707C235.817 79.4779 235.873 79.6367 235.986 79.7472C236.103 79.8577 236.265 79.9498 236.472 80.0235C236.68 80.0925 236.918 80.1731 237.189 80.2652C237.414 80.3481 237.616 80.4448 237.797 80.5552C237.977 80.6657 238.116 80.8085 238.216 80.9834C238.319 81.1584 238.371 81.3817 238.371 81.6533C238.371 81.8835 238.312 82.1022 238.195 82.3094C238.078 82.512 237.9 82.6777 237.662 82.8066C237.427 82.9355 237.132 83 236.776 83Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M241.324 83C240.86 83 240.453 82.8964 240.102 82.6892C239.755 82.4774 239.482 82.1828 239.284 81.8052C239.09 81.4277 238.993 80.9926 238.993 80.5C238.993 80.0074 239.09 79.5746 239.284 79.2017C239.482 78.8241 239.755 78.5295 240.102 78.3177C240.453 78.1059 240.86 78 241.324 78C241.793 78 242.201 78.1059 242.547 78.3177C242.899 78.5295 243.171 78.8241 243.365 79.2017C243.559 79.5746 243.655 80.0074 243.655 80.5C243.655 80.9926 243.559 81.4277 243.365 81.8052C243.171 82.1828 242.899 82.4774 242.547 82.6892C242.201 82.8964 241.793 83 241.324 83ZM241.324 82.489C241.671 82.489 241.975 82.4107 242.237 82.2541C242.502 82.093 242.707 81.8651 242.851 81.5704C243 81.2712 243.074 80.9144 243.074 80.5C243.074 80.0856 243 79.7311 242.851 79.4365C242.707 79.1418 242.502 78.9162 242.237 78.7597C241.975 78.5985 241.671 78.518 241.324 78.518C240.978 78.518 240.671 78.5985 240.406 78.7597C240.144 78.9162 239.939 79.1418 239.791 79.4365C239.647 79.7311 239.574 80.0856 239.574 80.5C239.574 80.9144 239.647 81.2712 239.791 81.5704C239.939 81.8651 240.144 82.093 240.406 82.2541C240.671 82.4107 240.978 82.489 241.324 82.489Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M244.474 82.9171V78.0829H245.042L247.562 81.9572V78.0829H248.13V82.9171H247.562L245.042 79.0428V82.9171H244.474Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M251.387 82.9171V78.732L250.623 78.9047V78.5041L251.576 78.0829H251.961V82.9171H251.387Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M253.426 82.9171V78.732L252.662 78.9047V78.5041L253.615 78.0829H254V82.9171H253.426Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M228.964 138.439L228.948 137H214L214.017 138.439H228.964Z",
    fill: "#DDC8BA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M263.682 138.439L263.649 137H230.704L230.738 138.439H263.682Z",
    fill: "#DDC8BA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M228.964 145.205L228.948 143.766H214L214.017 145.205H228.964Z",
    fill: "#DDC8BA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M263.682 145.205L263.649 143.766H230.704L230.738 145.205H263.682Z",
    fill: "#DDC8BA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M263.682 141.814V140.375H246.531L246.564 141.814H263.682Z",
    fill: "#DDC8BA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M245.056 141.814V140.375H214L214.033 141.814H245.056Z",
    fill: "#DDC8BA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 91,
    r: 3,
    fill: "url(#paint11_linear_10322_10129)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 104,
    r: 3,
    fill: "url(#paint12_linear_10322_10129)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 117,
    r: 3,
    fill: "url(#paint13_linear_10322_10129)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M297.531 194.652C299.652 194.652 301.608 192.386 301.906 189.59C302.204 186.795 300.614 184.545 297.713 184.545C295.592 184.545 294.565 186.811 294.25 189.607C293.952 192.403 295.41 194.652 297.531 194.652ZM295.907 189.772C296.073 188.234 296.636 186.977 297.813 186.977C299.404 186.977 300.282 188.217 300.116 189.756C299.951 191.294 298.873 192.552 297.713 192.552C296.553 192.552 295.741 191.311 295.907 189.772Z",
    fill: "url(#paint14_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M297.531 194.652C299.652 194.652 301.608 192.386 301.906 189.59C302.204 186.795 300.614 184.545 297.713 184.545C295.592 184.545 294.565 186.811 294.25 189.607C293.952 192.403 295.41 194.652 297.531 194.652ZM295.907 189.772C296.073 188.234 296.636 186.977 297.813 186.977C299.404 186.977 300.282 188.217 300.116 189.756C299.951 191.294 298.873 192.552 297.713 192.552C296.553 192.552 295.741 191.311 295.907 189.772Z",
    fill: "#398191"
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M280.946 200.636L295.861 200.592C296.318 200.591 296.688 200.22 296.687 199.763L296.627 179.465C296.625 179.008 296.253 178.639 295.796 178.64L280.881 178.684C280.423 178.686 280.054 179.057 280.055 179.514L280.115 199.812C280.117 200.269 280.489 200.638 280.946 200.636Z",
    fill: "url(#paint15_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M291.584 178.671L295.876 178.684C296.324 178.685 296.687 179.05 296.686 179.497L296.626 199.827C296.624 200.274 296.259 200.637 295.811 200.636L291.519 200.623L291.584 178.671Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M281.456 179.747C281.456 179.747 284.39 183.204 284.373 189.97C284.357 196.753 281.473 198.953 281.473 198.953V179.73L281.456 179.747Z",
    fill: "#FFF7E6"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M289.162 177.613C289.925 172.402 279.716 174.9 279.716 170.566C279.716 166.231 294.499 166.231 294.499 163.618C294.499 161.004 285.798 162.212 285.798 158.953C285.798 155.694 296.007 154.403 292.858 151.145C292.858 151.145 295.46 152.551 294.598 154.073C293.736 155.595 290.472 157.431 290.472 158.837C290.472 160.243 299.603 160.789 299.603 163.932C299.603 167.075 285.666 168.696 285.666 170.549C285.666 173.047 292.543 172.071 289.179 177.596L289.162 177.613Z",
    fill: "url(#paint16_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10322_10129",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 303,
    y: 92,
    width: 99,
    height: 109
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M402 92.9971H303.464V200.64H402V92.9971Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10322_10129)"
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M368.889 121.946C368.889 126.363 371.143 129.953 373.911 129.953C376.678 129.953 378.932 126.363 378.932 121.946C378.932 117.529 376.678 113.939 373.911 113.939C371.143 113.939 368.889 117.529 368.889 121.946Z",
    fill: "url(#paint17_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M368.889 121.946C368.889 126.363 371.143 129.953 373.911 129.953C376.678 129.953 378.932 126.363 378.932 121.946C378.932 117.529 376.678 113.939 373.911 113.939C371.143 113.939 368.889 117.529 368.889 121.946Z",
    fill: "#A69B9B"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M365.741 121.946C365.741 127.389 368.508 131.789 371.922 131.789C375.336 131.789 378.103 127.389 378.103 121.946C378.103 116.504 375.336 112.104 371.922 112.104C368.508 112.104 365.741 116.504 365.741 121.946Z",
    fill: "url(#paint18_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M365.741 121.946C365.741 127.389 368.508 131.789 371.922 131.789C375.336 131.789 378.103 127.389 378.103 121.946C378.103 116.504 375.336 112.104 371.922 112.104C368.508 112.104 365.741 116.504 365.741 121.946Z",
    fill: "#463332"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M353.229 135.677H318.876V185.288H353.229V135.677Z",
    fill: "url(#paint19_linear_10322_10129)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M353.229 137.397H321.212V183.552H353.229V137.397Z",
    fill: "#FFF4EE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M340.916 157.198H323.831V158.786H340.916V157.198Z",
    fill: "#DDC8BA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M340.916 163.005H323.831V164.593H340.916V163.005Z",
    fill: "#DDC8BA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M332.962 160.127H323.831V161.715H332.962V160.127Z",
    fill: "#DDC8BA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M350.594 157.198H342.292V158.786H350.594V157.198Z",
    fill: "#DDC8BA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M350.594 160.127H334.337V161.715H350.594V160.127Z",
    fill: "#DDC8BA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M350.594 140.275H323.831V143.501H350.594V140.275Z",
    fill: "#DDC8BA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M340.916 146.43H323.831V148.018H340.916V146.43Z",
    fill: "#DDC8BA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M340.916 152.235H323.831V153.823H340.916V152.235Z",
    fill: "#DDC8BA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M332.962 149.357H323.831V150.946H332.962V149.357Z",
    fill: "#DDC8BA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M350.594 146.43H342.292V148.018H350.594V146.43Z",
    fill: "#DDC8BA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M350.594 149.357H334.337V150.946H350.594V149.357Z",
    fill: "#DDC8BA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M310.689 162.063C312.711 157.53 316.738 152.6 317.732 152.087C318.047 151.922 318.445 151.773 318.843 151.641V156.058C318.843 156.058 318.826 157.067 318.859 157.348C319.058 158.589 320.566 157.794 322.372 157.249C324.03 156.752 325.488 156.885 325.587 157.629C325.654 158.142 324.278 158.655 322.803 159.3C321.312 159.945 319.771 161.864 318.163 162.476C316.556 163.088 315.611 163.287 315.611 163.287C315.611 163.287 314.434 166.827 314.169 167.257L309.015 165.173L310.689 162.046V162.063Z",
    fill: "url(#paint20_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M309.297 164.66L309.115 165.239L314.169 167.29C314.434 166.877 315.611 163.32 315.611 163.32C315.611 163.32 316.572 163.122 318.163 162.509C319.771 161.897 321.312 159.978 322.803 159.333C324.295 158.688 325.654 158.175 325.587 157.662C325.587 157.58 325.504 157.547 325.455 157.48C324.858 158.175 322.803 158.539 321.925 159.019C320.897 159.581 320.218 160.657 318.793 161.699C317.931 162.327 316.042 162.41 314.965 162.675C313.888 162.923 312.148 163.701 310.093 163.138L309.264 164.677L309.297 164.66Z",
    fill: "#C3694D"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M306.099 196.223C300.017 189.556 308.402 163.469 308.402 163.469C308.402 163.469 312.595 162.311 315.429 167.935C315.429 167.935 317.02 185.239 314.236 190.235C311.451 195.231 306.099 196.207 306.099 196.207V196.223Z",
    fill: "url(#paint21_linear_10322_10129)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M364.912 148.216C369.155 146.628 376.894 157.397 385.378 169.043C397.178 185.238 402.58 194.8 397.327 199.151C391.493 203.981 383.009 192.765 373.496 181.483C363.984 170.185 354.19 152.203 364.912 148.216Z",
    fill: "url(#paint22_linear_10322_10129)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M348.904 98.3238C348.904 98.3238 345.689 96.256 341.662 99.3991C336.177 103.684 338.712 110.135 337.95 114.718L347.064 104.875L348.904 98.3238Z",
    fill: "url(#paint23_linear_10322_10129)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M362.774 126.711C361.88 130.416 361.565 133.543 361.266 137.894C360.852 144.015 364.084 147.025 364.084 147.025C360.14 148.051 352.848 148.663 348.606 146.562C348.606 146.562 351.936 145.57 350.677 137.166C349.815 131.409 362.758 126.711 362.758 126.711H362.774Z",
    fill: "url(#paint24_linear_10322_10129)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M344.893 101.847C344.496 106.81 351.953 109.407 355.615 111.922C361.25 115.759 360.753 122.228 360.753 122.228L364.349 121.616C364.349 121.616 373.347 124.461 375.601 123.816C377.142 106.545 372.966 98.4393 360.604 95.6105C349.832 93.1456 345.208 97.9595 344.893 101.847Z",
    fill: "url(#paint25_linear_10322_10129)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M379.545 211.956C376.645 200.359 376.695 194.321 376.397 184.379C376.131 175.893 377.441 168.994 374.143 155.694C371.64 145.586 362.062 146.231 353.61 145.983C350.196 145.884 346.02 146.877 343.203 148.746C336.889 152.931 332.614 165.917 334.221 171.608C335.878 177.464 339.69 177.828 339.673 186.563C339.673 193.874 336.077 201.004 333.359 211.525C332.879 215.496 364.233 220.458 379.529 211.939L379.545 211.956Z",
    fill: "url(#paint26_linear_10322_10129)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M347.396 146.843C347.396 146.843 350.031 150.317 358.118 150.169C363.702 150.069 366.917 147.373 366.917 147.373C366.917 147.373 358.88 143.336 347.396 146.843Z",
    fill: "url(#paint27_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M343.402 185.206C343.236 177.348 339.126 169.49 339.126 169.49L334.768 173.163C336.591 177.613 339.69 178.671 339.673 186.562C339.673 193.874 336.077 201.004 333.359 211.525C333.293 212.055 333.823 212.6 334.785 213.146C337.784 204.941 343.568 192.832 343.402 185.206Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M358.366 150.168C363.785 150.002 366.917 147.389 366.917 147.389C366.917 147.389 365.641 146.76 363.388 146.198C362.46 144.94 360.968 142.211 361.266 137.893C361.432 135.478 361.614 133.443 361.88 131.475L350.727 143.187C350.66 143.485 350.578 143.716 350.495 143.981C351.307 144.907 354.157 147.951 358.366 150.168Z",
    fill: "#AC6B53"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M347.678 147.919C343.104 145.934 333.475 156.19 322.919 167.29C308.253 182.725 301.31 191.972 306.729 196.885C312.744 202.328 323.251 191.674 334.917 181.037C346.584 170.4 359.195 152.964 347.678 147.935V147.919Z",
    fill: "url(#paint28_linear_10322_10129)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M375.949 115.164C375.949 121.136 380.191 135.181 376.347 139.829C374.507 142.046 366.901 144.246 359.079 144.444C351.373 144.643 343.452 142.856 340.618 140.755C334.901 136.52 339.557 126.959 340.485 118.605C341.413 110.251 344.479 98.6543 360.272 100.309C374.226 101.764 375.949 115.164 375.949 115.164Z",
    fill: "url(#paint29_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M342.921 115.362C342.921 115.362 343.982 100.424 359.792 100.275C373.911 100.143 375.601 113.113 375.601 113.113C375.601 113.113 375.203 97.0165 358.98 97.1819C340.187 97.3474 339.69 114.419 339.69 114.419L342.921 115.346V115.362Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M339.574 112.054C339.06 112.054 338.563 112.153 338.082 112.318C338.082 113.162 338.066 113.973 337.933 114.717L340.303 112.153C340.054 112.103 339.822 112.037 339.557 112.037L339.574 112.054Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M339.574 133.328C343.336 133.328 346.368 128.563 346.368 122.691C346.368 117.943 344.363 113.956 341.612 112.6C341.049 114.634 340.701 116.702 340.485 118.621C339.955 123.419 338.198 128.613 337.884 132.964C338.43 133.179 338.994 133.344 339.574 133.344V133.328Z",
    fill: "#491D17"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M375.949 115.164C375.949 115.164 375.899 114.866 375.8 114.387C375.386 108.018 373.579 103.502 370.232 100.358C373.132 105.156 373.099 111.541 363.255 112.716C346.02 114.767 339.508 105.867 339.806 101.351C336.84 105.487 338.596 110.813 337.95 114.734L342.557 109.755C341.364 112.666 340.8 115.809 340.502 118.605C339.574 126.959 334.917 136.504 340.634 140.756C343.468 142.857 351.39 144.643 359.096 144.445C366.917 144.246 374.524 142.029 376.363 139.829C380.208 135.181 375.966 121.136 375.966 115.164H375.949Z",
    fill: "#491D17"
  }))), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M342.076 114.237C342.076 114.237 343.17 99.2993 359.377 99.1504C373.861 99.0181 375.584 111.988 375.584 111.988C375.584 111.988 375.17 95.8915 358.532 96.0569C339.259 96.2224 338.745 113.294 338.745 113.294L342.06 114.221L342.076 114.237Z",
    fill: "url(#paint30_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M359.178 98.1409C343.518 98.2898 341.248 112.119 341.032 113.939L342.093 114.237C342.093 114.237 343.187 99.2989 359.394 99.15C373.878 99.0176 375.601 111.987 375.601 111.987C375.601 111.987 375.369 109.109 373.911 105.8C371.79 102.161 367.547 98.0582 359.178 98.1409Z",
    fill: "#463332"
  }))), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M338.961 131.74C342.375 131.74 345.142 127.333 345.142 121.897C345.142 116.461 342.375 112.054 338.961 112.054C335.547 112.054 332.779 116.461 332.779 121.897C332.779 127.333 335.547 131.74 338.961 131.74Z",
    fill: "url(#paint31_linear_10322_10129)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M341.927 121.946C341.927 126.363 339.673 129.953 336.906 129.953C334.138 129.953 331.885 126.363 331.885 121.946C331.885 117.529 334.138 113.939 336.906 113.939C339.673 113.939 341.927 117.529 341.927 121.946Z",
    fill: "url(#paint32_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M338.961 112.054C338.812 112.054 338.696 112.103 338.546 112.12C341.43 112.732 343.651 116.636 343.651 121.384C343.651 126.578 341.016 130.78 337.751 130.78C336.956 130.78 336.193 130.515 335.497 130.052C336.492 131.111 337.668 131.74 338.961 131.74C342.375 131.74 345.142 127.339 345.142 121.897C345.142 116.454 342.375 112.054 338.961 112.054Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M336.906 113.939C335.978 113.939 335.116 114.37 334.354 115.081C334.818 114.816 335.298 114.634 335.829 114.634C338.165 114.634 340.071 117.662 340.071 121.4C340.071 125.139 338.165 128.166 335.829 128.166C334.337 128.166 333.028 126.925 332.266 125.056C333.028 127.951 334.818 129.969 336.906 129.969C339.69 129.969 341.927 126.38 341.927 121.963C341.927 117.546 339.673 113.956 336.906 113.956V113.939Z",
    fill: "#A69B9B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M336.011 115.974C338.348 116.371 335.564 120.524 334.321 120.342C332.382 120.061 333.973 115.627 336.011 115.974Z",
    fill: "#FFF7E6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M333.591 120.987C335.05 120.755 334.503 122.923 333.807 123.005C332.73 123.138 332.448 121.169 333.591 120.987Z",
    fill: "#FFF7E6"
  }))), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M396.034 188.58C394.642 212.335 386.074 226 368.989 226C351.903 226 344.927 212.335 346.319 188.58C347.711 164.825 354.091 139.994 374.027 139.994C393.963 139.994 397.443 164.825 396.051 188.58H396.034Z",
    fill: "url(#paint33_linear_10322_10129)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M399.796 188.58C398.404 212.335 389.836 226 372.751 226C355.665 226 348.688 212.335 350.08 188.58C351.472 164.825 357.853 139.994 377.789 139.994C397.724 139.994 401.205 164.825 399.813 188.58H399.796Z",
    fill: "url(#paint34_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M385.478 141.582C395.338 148.977 397.178 167.389 396.134 185.222C394.791 208.216 386.489 221.45 369.934 221.45C362.145 221.45 356.56 218.489 352.931 212.98C356.394 221.417 362.874 225.999 372.734 225.999C389.82 225.999 398.404 212.335 399.779 188.58C400.956 168.315 398.57 147.306 385.461 141.565L385.478 141.582Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M341.264 174.618C341.264 174.618 343.336 169.622 342.839 168.415C342.839 168.415 335.265 176.239 334.105 177.282C323.516 186.943 313.424 198.192 307.971 193.245C302.967 188.713 307.01 171.508 309.413 163.386C308.783 163.386 308.402 163.485 308.402 163.485C308.402 163.485 300.464 188.233 305.701 195.644C305.784 195.776 305.867 195.925 305.966 196.058C306.016 196.107 306.033 196.19 306.082 196.24H306.115C306.298 196.471 306.48 196.686 306.712 196.901C312.728 202.344 323.234 191.69 334.901 181.053C336.193 179.879 339.673 176.471 341.264 174.635V174.618Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M315.793 174.337C315.661 170.714 315.412 167.952 315.412 167.952C312.595 162.311 308.386 163.485 308.386 163.485C308.386 163.485 300 189.573 306.082 196.24C302.552 189.325 312.479 178.556 315.661 175.148L315.777 174.354L315.793 174.337Z",
    fill: "#A0335D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M319.804 158.009C319.804 158.009 319.804 158.009 319.82 158.009C319.307 158.059 318.959 157.91 318.876 157.364C318.826 157.083 318.876 156.074 318.876 156.074V153.46C318.727 153.576 317.252 154.982 317.334 156.289C317.434 157.844 318.561 158.241 319.804 158.026V158.009Z",
    fill: "#C3694D"
  })))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M170.79 197.779V187.87H169.033V185.008H250.003C251.412 185.008 252.555 186.149 252.555 187.555V198.11C252.555 199.516 251.412 200.657 250.003 200.657H169.033V197.795H170.79V197.779Z",
    fill: "url(#paint35_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M250.003 185.008H213.015V200.641H250.003C251.412 200.641 252.555 199.499 252.555 198.093V187.539C252.555 186.133 251.412 184.991 250.003 184.991V185.008Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M248.744 197.778H172.944V187.869H248.744C249.639 187.869 250.351 188.597 250.351 189.474V196.157C250.351 197.05 249.622 197.762 248.744 197.762V197.778Z",
    fill: "#60578F"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M246.589 197.778H170.79V187.869H246.589C247.484 187.869 248.197 188.597 248.197 189.474V196.157C248.197 197.05 247.468 197.762 246.589 197.762V197.778Z",
    fill: "#CEB6AA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M211.324 187.87H170.79V197.779H211.324V187.87Z",
    fill: "#CEB6AA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M211.324 187.87H170.79V197.779H211.324V187.87Z",
    fill: "#FFE6D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M209.949 187.87H246.573C247.468 187.87 248.18 188.598 248.18 189.475V191.758C248.18 190.864 247.451 190.153 246.573 190.153H209.949V187.87Z",
    fill: "#B29B93"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M245.462 192.171C245.462 192.171 244.402 192.254 242.794 192.336C241.187 192.419 239.049 192.452 236.911 192.469C234.774 192.452 232.636 192.419 231.028 192.336C229.421 192.254 228.36 192.171 228.36 192.171C228.36 192.171 229.437 192.088 231.028 192.005C232.636 191.923 234.774 191.89 236.911 191.873C239.049 191.89 241.187 191.923 242.794 192.005C244.402 192.088 245.462 192.171 245.462 192.171Z",
    fill: "#B29B93"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M209.303 193.991C209.303 193.991 207.297 194.057 204.298 194.14C201.298 194.206 197.305 194.239 193.311 194.256C189.317 194.239 185.307 194.206 182.324 194.14C179.324 194.057 177.319 193.991 177.319 193.991C177.319 193.991 179.324 193.925 182.324 193.842C185.323 193.776 189.317 193.743 193.311 193.727C197.305 193.743 201.315 193.776 204.298 193.842C207.297 193.925 209.303 193.991 209.303 193.991Z",
    fill: "#CEB6AA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M186.202 191.658C186.202 191.658 185.34 191.741 184.064 191.807C182.788 191.873 181.064 191.906 179.357 191.923C177.65 191.906 175.944 191.873 174.651 191.807C173.375 191.741 172.513 191.658 172.513 191.658C172.513 191.658 173.375 191.576 174.651 191.509C175.927 191.443 177.65 191.41 179.357 191.394C181.064 191.41 182.771 191.443 184.064 191.509C185.34 191.576 186.202 191.658 186.202 191.658Z",
    fill: "#CEB6AA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M211.324 187.87H170.79V190.12H211.324V187.87Z",
    fill: "#CEB6AA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M239.364 176.587V170.45H240.756V168.2H177.004C175.894 168.2 174.999 169.093 174.999 170.202V176.852C174.999 177.96 175.894 178.854 177.004 178.854H240.756V176.604H239.364V176.587Z",
    fill: "url(#paint36_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M177.999 170.45H237.674V176.587H177.999C177.302 176.587 176.722 176.025 176.722 175.314V171.707C176.722 171.013 177.286 170.434 177.999 170.434V170.45Z",
    fill: "#A0335D"
  }))), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M179.689 170.45H239.364V176.587H179.689C178.993 176.587 178.413 176.025 178.413 175.314V171.707C178.413 171.013 178.976 170.434 179.689 170.434V170.45Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M240.756 170.45V168.2H208.226V178.854H240.756V176.604H239.364V170.467H240.756V170.45Z",
    fill: "#A0335D"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M239.364 170.45H207.447V176.588H239.364V170.45Z",
    fill: "#CEB6AA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M239.364 170.45H207.447V176.588H239.364V170.45Z",
    fill: "#CEB6AA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M208.524 170.45H179.689C178.993 170.45 178.413 171.013 178.413 171.724V173.527C178.413 172.832 178.976 172.253 179.689 172.253H208.524V170.45Z",
    fill: "#CEB6AA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M180.567 173.494L182.672 173.362C183.931 173.296 185.622 173.279 187.295 173.246C188.986 173.263 190.659 173.279 191.919 173.345C193.178 173.428 194.023 173.478 194.023 173.478C194.023 173.478 193.178 173.527 191.919 173.61C190.659 173.676 188.969 173.693 187.295 173.709C185.605 173.693 183.931 173.676 182.672 173.594C181.412 173.511 180.567 173.461 180.567 173.461V173.494Z",
    fill: "#CEB6AA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M184.578 175.149C184.578 175.149 185.804 175.099 187.66 175.016C189.516 174.95 191.969 174.933 194.438 174.9C196.907 174.917 199.376 174.933 201.216 175C203.072 175.082 204.298 175.132 204.298 175.132C204.298 175.132 203.072 175.182 201.216 175.264C199.36 175.331 196.907 175.347 194.438 175.364C191.969 175.347 189.499 175.331 187.66 175.248C185.804 175.165 184.578 175.115 184.578 175.115V175.149Z",
    fill: "#CEB6AA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M209.038 173.609C209.038 173.609 210.612 173.543 212.965 173.461C215.318 173.378 218.467 173.361 221.616 173.345C224.764 173.361 227.913 173.394 230.266 173.461C232.619 173.56 234.194 173.609 234.194 173.609C234.194 173.609 232.619 173.676 230.266 173.758C227.913 173.841 224.764 173.858 221.616 173.874C218.467 173.858 215.318 173.824 212.965 173.758C210.612 173.659 209.038 173.609 209.038 173.609Z",
    fill: "#B29B93"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M218.898 175.214C218.898 175.214 223.008 174.966 227.117 174.982C231.227 174.966 235.337 175.214 235.337 175.214C235.337 175.214 231.227 175.462 227.117 175.445C223.008 175.462 218.898 175.214 218.898 175.214Z",
    fill: "#B29B93"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M239.364 170.45H207.447V172.22H239.364V170.45Z",
    fill: "#B29B93"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M170.276 183.651V180.259H169V178.771H250.699C251.71 178.771 252.539 179.465 252.539 180.326V183.584C252.539 184.445 251.71 185.139 250.699 185.139H169V183.651H170.276Z",
    fill: "url(#paint37_linear_10322_10129)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M250.699 178.771H210.264V185.139H250.699C251.71 185.139 252.539 184.445 252.539 183.584V180.326C252.539 179.465 251.71 178.771 250.699 178.771Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M249.804 183.65H171.85V180.259H249.804C250.451 180.259 250.964 180.789 250.964 181.417V182.492C250.964 183.138 250.434 183.65 249.804 183.65Z",
    fill: "#AA2424"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M248.246 183.65H170.293V180.259H248.246C248.893 180.259 249.407 180.789 249.407 181.417V182.492C249.407 183.138 248.876 183.65 248.246 183.65Z",
    fill: "#CEB6AA"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M210.993 180.26H170.276V183.651H210.993V180.26Z",
    fill: "#CEB6AA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M210.993 180.26H170.276V183.651H210.993V180.26Z",
    fill: "#FFE6D6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M209.999 180.26H248.247C248.893 180.26 249.407 180.789 249.407 181.418V183.072C249.407 182.427 248.876 181.914 248.247 181.914H209.999V180.26Z",
    fill: "#B29B93"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M210.993 180.26H170.276V181.881H210.993V180.26Z",
    fill: "#CEB6AA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M30.62 67V55.06H26.54V53H37.28V55.06H33.18V67H30.62ZM41.9195 67.24C40.9195 67.24 40.0329 67.0267 39.2595 66.6C38.4862 66.1733 37.8795 65.5733 37.4395 64.8C36.9995 64.0267 36.7795 63.1333 36.7795 62.12C36.7795 61.0933 36.9929 60.18 37.4195 59.38C37.8595 58.58 38.4595 57.96 39.2195 57.52C39.9929 57.0667 40.8995 56.84 41.9395 56.84C42.9129 56.84 43.7729 57.0533 44.5195 57.48C45.2662 57.9067 45.8462 58.4933 46.2595 59.24C46.6862 59.9733 46.8995 60.7933 46.8995 61.7C46.8995 61.8467 46.8929 62 46.8795 62.16C46.8795 62.32 46.8729 62.4867 46.8595 62.66H39.3195C39.3729 63.4333 39.6395 64.04 40.1195 64.48C40.6129 64.92 41.2062 65.14 41.8995 65.14C42.4195 65.14 42.8529 65.0267 43.1995 64.8C43.5595 64.56 43.8262 64.2533 43.9995 63.88H46.5995C46.4129 64.5067 46.0995 65.08 45.6595 65.6C45.2329 66.1067 44.6995 66.5067 44.0595 66.8C43.4329 67.0933 42.7195 67.24 41.9195 67.24ZM41.9395 58.92C41.3129 58.92 40.7595 59.1 40.2795 59.46C39.7995 59.8067 39.4929 60.34 39.3595 61.06H44.2995C44.2595 60.4067 44.0195 59.8867 43.5795 59.5C43.1395 59.1133 42.5929 58.92 41.9395 58.92ZM52.2527 67.24C51.3993 67.24 50.6993 67.1067 50.1527 66.84C49.606 66.56 49.1993 66.1933 48.9327 65.74C48.666 65.2867 48.5327 64.7867 48.5327 64.24C48.5327 63.32 48.8927 62.5733 49.6127 62C50.3327 61.4267 51.4127 61.14 52.8527 61.14H55.3727V60.9C55.3727 60.22 55.1793 59.72 54.7927 59.4C54.406 59.08 53.926 58.92 53.3527 58.92C52.8327 58.92 52.3793 59.0467 51.9927 59.3C51.606 59.54 51.366 59.9 51.2727 60.38H48.7727C48.8393 59.66 49.0793 59.0333 49.4927 58.5C49.9193 57.9667 50.466 57.56 51.1327 57.28C51.7993 56.9867 52.546 56.84 53.3727 56.84C54.786 56.84 55.8993 57.1933 56.7127 57.9C57.526 58.6067 57.9327 59.6067 57.9327 60.9V67H55.7527L55.5127 65.4C55.2193 65.9333 54.806 66.3733 54.2727 66.72C53.7527 67.0667 53.0793 67.24 52.2527 67.24ZM52.8327 65.24C53.566 65.24 54.1327 65 54.5327 64.52C54.946 64.04 55.206 63.4467 55.3127 62.74H53.1327C52.4527 62.74 51.966 62.8667 51.6727 63.12C51.3793 63.36 51.2327 63.66 51.2327 64.02C51.2327 64.4067 51.3793 64.7067 51.6727 64.92C51.966 65.1333 52.3527 65.24 52.8327 65.24ZM65.0156 67.24C64.0023 67.24 63.109 67.02 62.3356 66.58C61.5623 66.14 60.949 65.5267 60.4956 64.74C60.0556 63.9533 59.8356 63.0533 59.8356 62.04C59.8356 61.0267 60.0556 60.1267 60.4956 59.34C60.949 58.5533 61.5623 57.94 62.3356 57.5C63.109 57.06 64.0023 56.84 65.0156 56.84C66.2823 56.84 67.349 57.1733 68.2156 57.84C69.0823 58.4933 69.6356 59.4 69.8756 60.56H67.1756C67.0423 60.08 66.7756 59.7067 66.3756 59.44C65.989 59.16 65.529 59.02 64.9956 59.02C64.289 59.02 63.689 59.2867 63.1956 59.82C62.7023 60.3533 62.4556 61.0933 62.4556 62.04C62.4556 62.9867 62.7023 63.7267 63.1956 64.26C63.689 64.7933 64.289 65.06 64.9956 65.06C65.529 65.06 65.989 64.9267 66.3756 64.66C66.7756 64.3933 67.0423 64.0133 67.1756 63.52H69.8756C69.6356 64.64 69.0823 65.54 68.2156 66.22C67.349 66.9 66.2823 67.24 65.0156 67.24ZM71.9278 67V52.6H74.4878V58.6C74.8211 58.0533 75.2678 57.6267 75.8278 57.32C76.4011 57 77.0545 56.84 77.7878 56.84C79.0145 56.84 79.9611 57.2267 80.6278 58C81.3078 58.7733 81.6478 59.9067 81.6478 61.4V67H79.1078V61.64C79.1078 60.7867 78.9345 60.1333 78.5878 59.68C78.2545 59.2267 77.7211 59 76.9878 59C76.2678 59 75.6678 59.2533 75.1878 59.76C74.7211 60.2667 74.4878 60.9733 74.4878 61.88V67H71.9278ZM88.6958 67.24C87.6958 67.24 86.8091 67.0267 86.0358 66.6C85.2624 66.1733 84.6558 65.5733 84.2158 64.8C83.7758 64.0267 83.5558 63.1333 83.5558 62.12C83.5558 61.0933 83.7691 60.18 84.1958 59.38C84.6358 58.58 85.2358 57.96 85.9958 57.52C86.7691 57.0667 87.6758 56.84 88.7158 56.84C89.6891 56.84 90.5491 57.0533 91.2958 57.48C92.0424 57.9067 92.6224 58.4933 93.0358 59.24C93.4624 59.9733 93.6758 60.7933 93.6758 61.7C93.6758 61.8467 93.6691 62 93.6558 62.16C93.6558 62.32 93.6491 62.4867 93.6358 62.66H86.0958C86.1491 63.4333 86.4158 64.04 86.8958 64.48C87.3891 64.92 87.9824 65.14 88.6758 65.14C89.1958 65.14 89.6291 65.0267 89.9758 64.8C90.3358 64.56 90.6024 64.2533 90.7758 63.88H93.3758C93.1891 64.5067 92.8758 65.08 92.4358 65.6C92.0091 66.1067 91.4758 66.5067 90.8358 66.8C90.2091 67.0933 89.4958 67.24 88.6958 67.24ZM88.7158 58.92C88.0891 58.92 87.5358 59.1 87.0558 59.46C86.5758 59.8067 86.2691 60.34 86.1358 61.06H91.0758C91.0358 60.4067 90.7958 59.8867 90.3558 59.5C89.9158 59.1133 89.3691 58.92 88.7158 58.92ZM95.6089 67V57.08H97.8889L98.1289 58.94C98.4889 58.3 98.9756 57.7933 99.5889 57.42C100.216 57.0333 100.949 56.84 101.789 56.84V59.54H101.069C100.509 59.54 100.009 59.6267 99.5689 59.8C99.1289 59.9733 98.7822 60.2733 98.5289 60.7C98.2889 61.1267 98.1689 61.72 98.1689 62.48V67H95.6089Z",
    fill: "#FFB900"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M26.644 96L33.812 76.4H37.844L45.012 96H41.204L39.636 91.464H31.992L30.396 96H26.644ZM32.972 88.664H38.656L35.8 80.516L32.972 88.664ZM52.8848 96.336C51.6528 96.336 50.5701 96.14 49.6368 95.748C48.7035 95.3373 47.9568 94.7773 47.3968 94.068C46.8368 93.3587 46.5008 92.5373 46.3888 91.604H50.0008C50.1128 92.1453 50.4115 92.612 50.8968 93.004C51.4008 93.3773 52.0448 93.564 52.8288 93.564C53.6128 93.564 54.1821 93.4053 54.5368 93.088C54.9101 92.7707 55.0968 92.4067 55.0968 91.996C55.0968 91.3987 54.8355 90.9973 54.3128 90.792C53.7901 90.568 53.0621 90.3533 52.1288 90.148C51.5315 90.0173 50.9248 89.8587 50.3088 89.672C49.6928 89.4853 49.1235 89.252 48.6008 88.972C48.0968 88.6733 47.6861 88.3 47.3688 87.852C47.0515 87.3853 46.8928 86.816 46.8928 86.144C46.8928 84.912 47.3781 83.876 48.3488 83.036C49.3381 82.196 50.7195 81.776 52.4928 81.776C54.1355 81.776 55.4421 82.1587 56.4128 82.924C57.4021 83.6893 57.9901 84.744 58.1768 86.088H54.7888C54.5835 85.0613 53.8088 84.548 52.4648 84.548C51.7928 84.548 51.2701 84.6787 50.8968 84.94C50.5421 85.2013 50.3648 85.528 50.3648 85.92C50.3648 86.3307 50.6355 86.6573 51.1768 86.9C51.7181 87.1427 52.4368 87.3667 53.3328 87.572C54.3035 87.796 55.1901 88.048 55.9928 88.328C56.8141 88.5893 57.4675 88.9907 57.9528 89.532C58.4381 90.0547 58.6808 90.8107 58.6808 91.8C58.6995 92.6587 58.4755 93.4333 58.0088 94.124C57.5421 94.8147 56.8701 95.356 55.9928 95.748C55.1155 96.14 54.0795 96.336 52.8848 96.336ZM67.2877 96.336C66.0557 96.336 64.9731 96.14 64.0397 95.748C63.1064 95.3373 62.3597 94.7773 61.7997 94.068C61.2397 93.3587 60.9037 92.5373 60.7917 91.604H64.4037C64.5157 92.1453 64.8144 92.612 65.2997 93.004C65.8037 93.3773 66.4477 93.564 67.2317 93.564C68.0157 93.564 68.5851 93.4053 68.9397 93.088C69.3131 92.7707 69.4997 92.4067 69.4997 91.996C69.4997 91.3987 69.2384 90.9973 68.7157 90.792C68.1931 90.568 67.4651 90.3533 66.5317 90.148C65.9344 90.0173 65.3277 89.8587 64.7117 89.672C64.0957 89.4853 63.5264 89.252 63.0037 88.972C62.4997 88.6733 62.0891 88.3 61.7717 87.852C61.4544 87.3853 61.2957 86.816 61.2957 86.144C61.2957 84.912 61.7811 83.876 62.7517 83.036C63.7411 82.196 65.1224 81.776 66.8957 81.776C68.5384 81.776 69.8451 82.1587 70.8157 82.924C71.8051 83.6893 72.3931 84.744 72.5797 86.088H69.1917C68.9864 85.0613 68.2117 84.548 66.8677 84.548C66.1957 84.548 65.6731 84.6787 65.2997 84.94C64.9451 85.2013 64.7677 85.528 64.7677 85.92C64.7677 86.3307 65.0384 86.6573 65.5797 86.9C66.1211 87.1427 66.8397 87.3667 67.7357 87.572C68.7064 87.796 69.5931 88.048 70.3957 88.328C71.2171 88.5893 71.8704 88.9907 72.3557 89.532C72.8411 90.0547 73.0837 90.8107 73.0837 91.8C73.1024 92.6587 72.8784 93.4333 72.4117 94.124C71.9451 94.8147 71.2731 95.356 70.3957 95.748C69.5184 96.14 68.4824 96.336 67.2877 96.336ZM77.8827 79.956C77.2294 79.956 76.688 79.76 76.2587 79.368C75.848 78.976 75.6427 78.4813 75.6427 77.884C75.6427 77.2867 75.848 76.8013 76.2587 76.428C76.688 76.036 77.2294 75.84 77.8827 75.84C78.536 75.84 79.068 76.036 79.4787 76.428C79.908 76.8013 80.1227 77.2867 80.1227 77.884C80.1227 78.4813 79.908 78.976 79.4787 79.368C79.068 79.76 78.536 79.956 77.8827 79.956ZM76.0907 96V82.112H79.6747V96H76.0907ZM88.8475 96.336C87.6155 96.336 86.5329 96.14 85.5995 95.748C84.6662 95.3373 83.9195 94.7773 83.3595 94.068C82.7995 93.3587 82.4635 92.5373 82.3515 91.604H85.9635C86.0755 92.1453 86.3742 92.612 86.8595 93.004C87.3635 93.3773 88.0075 93.564 88.7915 93.564C89.5755 93.564 90.1449 93.4053 90.4995 93.088C90.8729 92.7707 91.0595 92.4067 91.0595 91.996C91.0595 91.3987 90.7982 90.9973 90.2755 90.792C89.7529 90.568 89.0249 90.3533 88.0915 90.148C87.4942 90.0173 86.8875 89.8587 86.2715 89.672C85.6555 89.4853 85.0862 89.252 84.5635 88.972C84.0595 88.6733 83.6489 88.3 83.3315 87.852C83.0142 87.3853 82.8555 86.816 82.8555 86.144C82.8555 84.912 83.3409 83.876 84.3115 83.036C85.3009 82.196 86.6822 81.776 88.4555 81.776C90.0982 81.776 91.4049 82.1587 92.3755 82.924C93.3649 83.6893 93.9529 84.744 94.1395 86.088H90.7515C90.5462 85.0613 89.7715 84.548 88.4275 84.548C87.7555 84.548 87.2329 84.6787 86.8595 84.94C86.5049 85.2013 86.3275 85.528 86.3275 85.92C86.3275 86.3307 86.5982 86.6573 87.1395 86.9C87.6809 87.1427 88.3995 87.3667 89.2955 87.572C90.2662 87.796 91.1529 88.048 91.9555 88.328C92.7769 88.5893 93.4302 88.9907 93.9155 89.532C94.4009 90.0547 94.6435 90.8107 94.6435 91.8C94.6622 92.6587 94.4382 93.4333 93.9715 94.124C93.5049 94.8147 92.8329 95.356 91.9555 95.748C91.0782 96.14 90.0422 96.336 88.8475 96.336ZM103.261 96C101.805 96 100.638 95.6453 99.761 94.936C98.8836 94.2267 98.445 92.9667 98.445 91.156V85.108H96.065V82.112H98.445L98.865 78.388H102.029V82.112H105.781V85.108H102.029V91.184C102.029 91.856 102.169 92.3227 102.449 92.584C102.748 92.8267 103.252 92.948 103.961 92.948H105.697V96H103.261ZM113.338 96.336C112.143 96.336 111.163 96.1493 110.398 95.776C109.633 95.384 109.063 94.8707 108.69 94.236C108.317 93.6013 108.13 92.9013 108.13 92.136C108.13 90.848 108.634 89.8027 109.642 89C110.65 88.1973 112.162 87.796 114.178 87.796H117.706V87.46C117.706 86.508 117.435 85.808 116.894 85.36C116.353 84.912 115.681 84.688 114.878 84.688C114.15 84.688 113.515 84.8653 112.974 85.22C112.433 85.556 112.097 86.06 111.966 86.732H108.466C108.559 85.724 108.895 84.8467 109.474 84.1C110.071 83.3533 110.837 82.784 111.77 82.392C112.703 81.9813 113.749 81.776 114.906 81.776C116.885 81.776 118.443 82.2707 119.582 83.26C120.721 84.2493 121.29 85.6493 121.29 87.46V96H118.238L117.902 93.76C117.491 94.5067 116.913 95.1227 116.166 95.608C115.438 96.0933 114.495 96.336 113.338 96.336ZM114.15 93.536C115.177 93.536 115.97 93.2 116.53 92.528C117.109 91.856 117.473 91.0253 117.622 90.036H114.57C113.618 90.036 112.937 90.2133 112.526 90.568C112.115 90.904 111.91 91.324 111.91 91.828C111.91 92.3693 112.115 92.7893 112.526 93.088C112.937 93.3867 113.478 93.536 114.15 93.536ZM124.402 96V82.112H127.566L127.846 84.464C128.276 83.6427 128.892 82.9893 129.694 82.504C130.516 82.0187 131.477 81.776 132.578 81.776C134.296 81.776 135.63 82.3173 136.582 83.4C137.534 84.4827 138.01 86.0693 138.01 88.16V96H134.426V88.496C134.426 87.3013 134.184 86.3867 133.698 85.752C133.213 85.1173 132.457 84.8 131.43 84.8C130.422 84.8 129.592 85.1547 128.938 85.864C128.304 86.5733 127.986 87.5627 127.986 88.832V96H124.402ZM147.933 96.336C146.515 96.336 145.264 96.028 144.181 95.412C143.099 94.796 142.24 93.9373 141.605 92.836C140.989 91.7347 140.681 90.4747 140.681 89.056C140.681 87.6373 140.989 86.3773 141.605 85.276C142.24 84.1747 143.099 83.316 144.181 82.7C145.264 82.084 146.515 81.776 147.933 81.776C149.707 81.776 151.2 82.2427 152.413 83.176C153.627 84.0907 154.401 85.36 154.737 86.984H150.957C150.771 86.312 150.397 85.7893 149.837 85.416C149.296 85.024 148.652 84.828 147.905 84.828C146.916 84.828 146.076 85.2013 145.385 85.948C144.695 86.6947 144.349 87.7307 144.349 89.056C144.349 90.3813 144.695 91.4173 145.385 92.164C146.076 92.9107 146.916 93.284 147.905 93.284C148.652 93.284 149.296 93.0973 149.837 92.724C150.397 92.3507 150.771 91.8187 150.957 91.128H154.737C154.401 92.696 153.627 93.956 152.413 94.908C151.2 95.86 149.707 96.336 147.933 96.336ZM164.358 96.336C162.958 96.336 161.717 96.0373 160.634 95.44C159.552 94.8427 158.702 94.0027 158.086 92.92C157.47 91.8373 157.162 90.5867 157.162 89.168C157.162 87.7307 157.461 86.452 158.058 85.332C158.674 84.212 159.514 83.344 160.578 82.728C161.661 82.0933 162.93 81.776 164.386 81.776C165.749 81.776 166.953 82.0747 167.998 82.672C169.044 83.2693 169.856 84.0907 170.434 85.136C171.032 86.1627 171.33 87.3107 171.33 88.58C171.33 88.7853 171.321 89 171.302 89.224C171.302 89.448 171.293 89.6813 171.274 89.924H160.718C160.793 91.0067 161.166 91.856 161.838 92.472C162.529 93.088 163.36 93.396 164.33 93.396C165.058 93.396 165.665 93.2373 166.15 92.92C166.654 92.584 167.028 92.1547 167.27 91.632H170.91C170.649 92.5093 170.21 93.312 169.594 94.04C168.997 94.7493 168.25 95.3093 167.354 95.72C166.477 96.1307 165.478 96.336 164.358 96.336ZM164.386 84.688C163.509 84.688 162.734 84.94 162.062 85.444C161.39 85.9293 160.961 86.676 160.774 87.684H167.69C167.634 86.7693 167.298 86.0413 166.682 85.5C166.066 84.9587 165.301 84.688 164.386 84.688ZM34.596 126.336C33.1587 126.336 31.8893 126.093 30.788 125.608C29.6867 125.104 28.8187 124.395 28.184 123.48C27.5493 122.547 27.2227 121.417 27.204 120.092H30.984C31.0213 121.007 31.348 121.781 31.964 122.416C32.5987 123.032 33.4667 123.34 34.568 123.34C35.52 123.34 36.276 123.116 36.836 122.668C37.396 122.201 37.676 121.585 37.676 120.82C37.676 120.017 37.424 119.392 36.92 118.944C36.4347 118.496 35.7813 118.132 34.96 117.852C34.1387 117.572 33.2613 117.273 32.328 116.956C30.816 116.433 29.6587 115.761 28.856 114.94C28.072 114.119 27.68 113.027 27.68 111.664C27.6613 110.507 27.932 109.517 28.492 108.696C29.0707 107.856 29.8547 107.212 30.844 106.764C31.8333 106.297 32.972 106.064 34.26 106.064C35.5667 106.064 36.7147 106.297 37.704 106.764C38.712 107.231 39.496 107.884 40.056 108.724C40.6347 109.564 40.9427 110.563 40.98 111.72H37.144C37.1253 111.029 36.8547 110.423 36.332 109.9C35.828 109.359 35.1187 109.088 34.204 109.088C33.42 109.069 32.7573 109.265 32.216 109.676C31.6933 110.068 31.432 110.647 31.432 111.412C31.432 112.065 31.6373 112.588 32.048 112.98C32.4587 113.353 33.0187 113.671 33.728 113.932C34.4373 114.193 35.2493 114.473 36.164 114.772C37.1347 115.108 38.0213 115.5 38.824 115.948C39.6267 116.396 40.2707 116.993 40.756 117.74C41.2413 118.468 41.484 119.411 41.484 120.568C41.484 121.595 41.2227 122.547 40.7 123.424C40.1773 124.301 39.4027 125.011 38.376 125.552C37.3493 126.075 36.0893 126.336 34.596 126.336ZM45.955 132.16L49.175 125.076H48.335L42.931 112.112H46.823L50.715 121.884L54.775 112.112H58.583L49.763 132.16H45.955ZM65.6745 126.336C64.4425 126.336 63.3598 126.14 62.4265 125.748C61.4931 125.337 60.7465 124.777 60.1865 124.068C59.6265 123.359 59.2905 122.537 59.1785 121.604H62.7905C62.9025 122.145 63.2011 122.612 63.6865 123.004C64.1905 123.377 64.8345 123.564 65.6185 123.564C66.4025 123.564 66.9718 123.405 67.3265 123.088C67.6998 122.771 67.8865 122.407 67.8865 121.996C67.8865 121.399 67.6251 120.997 67.1025 120.792C66.5798 120.568 65.8518 120.353 64.9185 120.148C64.3211 120.017 63.7145 119.859 63.0985 119.672C62.4825 119.485 61.9131 119.252 61.3905 118.972C60.8865 118.673 60.4758 118.3 60.1585 117.852C59.8411 117.385 59.6825 116.816 59.6825 116.144C59.6825 114.912 60.1678 113.876 61.1385 113.036C62.1278 112.196 63.5091 111.776 65.2825 111.776C66.9251 111.776 68.2318 112.159 69.2025 112.924C70.1918 113.689 70.7798 114.744 70.9665 116.088H67.5785C67.3731 115.061 66.5985 114.548 65.2545 114.548C64.5825 114.548 64.0598 114.679 63.6865 114.94C63.3318 115.201 63.1545 115.528 63.1545 115.92C63.1545 116.331 63.4251 116.657 63.9665 116.9C64.5078 117.143 65.2265 117.367 66.1225 117.572C67.0931 117.796 67.9798 118.048 68.7825 118.328C69.6038 118.589 70.2571 118.991 70.7425 119.532C71.2278 120.055 71.4705 120.811 71.4705 121.8C71.4891 122.659 71.2651 123.433 70.7985 124.124C70.3318 124.815 69.6598 125.356 68.7825 125.748C67.9051 126.14 66.8691 126.336 65.6745 126.336ZM80.0879 126C78.6319 126 77.4652 125.645 76.5879 124.936C75.7106 124.227 75.2719 122.967 75.2719 121.156V115.108H72.8919V112.112H75.2719L75.6919 108.388H78.8559V112.112H82.6079V115.108H78.8559V121.184C78.8559 121.856 78.9959 122.323 79.2759 122.584C79.5746 122.827 80.0786 122.948 80.7879 122.948H82.5239V126H80.0879ZM91.7696 126.336C90.3696 126.336 89.1283 126.037 88.0456 125.44C86.9629 124.843 86.1136 124.003 85.4976 122.92C84.8816 121.837 84.5736 120.587 84.5736 119.168C84.5736 117.731 84.8723 116.452 85.4696 115.332C86.0856 114.212 86.9256 113.344 87.9896 112.728C89.0723 112.093 90.3416 111.776 91.7976 111.776C93.1603 111.776 94.3643 112.075 95.4096 112.672C96.4549 113.269 97.2669 114.091 97.8456 115.136C98.4429 116.163 98.7416 117.311 98.7416 118.58C98.7416 118.785 98.7323 119 98.7136 119.224C98.7136 119.448 98.7043 119.681 98.6856 119.924H88.1296C88.2043 121.007 88.5776 121.856 89.2496 122.472C89.9403 123.088 90.7709 123.396 91.7416 123.396C92.4696 123.396 93.0763 123.237 93.5616 122.92C94.0656 122.584 94.4389 122.155 94.6816 121.632H98.3216C98.0603 122.509 97.6216 123.312 97.0056 124.04C96.4083 124.749 95.6616 125.309 94.7656 125.72C93.8883 126.131 92.8896 126.336 91.7696 126.336ZM91.7976 114.688C90.9203 114.688 90.1456 114.94 89.4736 115.444C88.8016 115.929 88.3723 116.676 88.1856 117.684H95.1016C95.0456 116.769 94.7096 116.041 94.0936 115.5C93.4776 114.959 92.7123 114.688 91.7976 114.688ZM101.448 126V112.112H104.612L104.92 113.988C105.368 113.316 105.956 112.784 106.684 112.392C107.431 111.981 108.289 111.776 109.26 111.776C111.407 111.776 112.928 112.607 113.824 114.268C114.328 113.503 115 112.896 115.84 112.448C116.699 112 117.632 111.776 118.64 111.776C120.451 111.776 121.841 112.317 122.812 113.4C123.783 114.483 124.268 116.069 124.268 118.16V126H120.684V118.496C120.684 117.301 120.451 116.387 119.984 115.752C119.536 115.117 118.836 114.8 117.884 114.8C116.913 114.8 116.129 115.155 115.532 115.864C114.953 116.573 114.664 117.563 114.664 118.832V126H111.08V118.496C111.08 117.301 110.847 116.387 110.38 115.752C109.913 115.117 109.195 114.8 108.224 114.8C107.272 114.8 106.497 115.155 105.9 115.864C105.321 116.573 105.032 117.563 105.032 118.832V126H101.448Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10322_10129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6114 38.5255C53.6114 40.5598 54.2229 40.6274 55.2919 40.6274V40.8476H50.8106V40.6274C51.6427 40.6274 51.9309 40.1869 51.9309 38.5768V30.7299C51.9309 29.5601 51.6929 29.1372 50.8445 29.1372V28.917H53.9172C57.2957 28.917 59.5363 29.3236 59.5363 32.34C59.5363 35.3565 57.2957 35.7468 53.9172 35.7468H53.6114V38.5267V38.5255ZM53.9172 35.5254C55.9886 35.5254 57.6855 35.4753 57.6855 32.34C57.6855 29.2048 55.9034 29.1372 53.9172 29.1372H53.6114V35.5266H53.9172V35.5254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.965 40.8468H60.1128V40.6266C60.7582 40.4402 60.792 40.1349 60.792 39.2704V34.5763C60.792 33.9832 60.6566 33.7456 59.9436 33.5592V33.3553L62.2695 32.8636V39.2704C62.2695 40.2188 62.3546 40.474 62.965 40.6266V40.8468ZM60.5038 30.594C60.5038 30.1023 60.8772 29.7295 61.3697 29.7295C61.8622 29.7295 62.2356 30.1023 62.2356 30.594C62.2356 31.0857 61.8447 31.4585 61.3697 31.4585C60.8947 31.4585 60.5038 31.0682 60.5038 30.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0792 40.8475H68.227V40.6436C68.8724 40.4572 68.9062 40.1356 68.9062 39.2711V35.6267C68.9062 34.4744 68.2947 33.7113 67.1744 33.7113C66.2922 33.7113 65.5791 34.5583 65.4426 35.1688V39.2874C65.4426 40.2195 65.5278 40.4735 66.1381 40.6261V40.8463H63.2859V40.6261C63.9313 40.4397 63.9476 40.1519 63.9476 39.2874V34.5595C63.9476 33.9664 63.8111 33.7462 63.0992 33.5598V33.3559L65.4414 32.8643V34.6434C65.7973 33.66 66.969 32.8643 68.0392 32.8643C69.4139 32.8643 70.3813 33.5249 70.3813 35.5754V39.2699C70.3813 40.202 70.4829 40.4898 71.0769 40.6424V40.8463L71.0792 40.8475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9904 40.8475H76.1382V40.6436C76.7836 40.4572 76.8174 40.1356 76.8174 39.2711V35.6267C76.8174 34.4744 76.2059 33.7113 75.0856 33.7113C74.2033 33.7113 73.4903 34.5583 73.3537 35.1688V39.2874C73.3537 40.2195 73.4389 40.4735 74.0493 40.6261V40.8463H71.1971V40.6261C71.8425 40.4397 71.8588 40.1519 71.8588 39.2874V34.5595C71.8588 33.9664 71.7234 33.7462 71.0104 33.5598V33.3559L73.3526 32.8643V34.6434C73.7085 33.66 74.8802 32.8643 75.9503 32.8643C77.3251 32.8643 78.2925 33.5249 78.2925 35.5754V39.2699C78.2925 40.202 78.394 40.4898 78.988 40.6424V40.8463L78.9904 40.8475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5958 39.7629L86.7988 39.8479C86.6973 40.3571 86.1196 41.0002 85.2374 41.0002C85.2374 41.0002 83.8965 41.034 83.7949 39.5765C83.5569 40.3897 82.5731 41.0002 81.3839 41.0002C81.3839 41.0002 79.449 41.0002 79.449 39.2549C79.449 37.5096 80.8914 37.1869 83.7949 36.4424V35.459C83.7949 33.7137 82.9127 32.7304 81.5543 33.3572C80.8926 33.6799 80.7911 34.0015 80.8926 34.0178C81.0968 34.0516 81.2835 34.1366 81.4189 34.3231C81.6733 34.6621 81.6056 35.1712 81.2485 35.4252C80.9089 35.6967 80.4165 35.628 80.162 35.2726C79.9753 35.0186 79.9415 34.6796 80.0769 34.4419C80.1959 34.1879 80.4841 33.6799 81.4014 33.1883C82.1308 32.8154 82.9629 32.8655 82.9629 32.8655C84.8126 32.8655 85.3226 34.238 85.3226 36.2548V39.1361C85.3226 39.1361 85.3062 40.2033 86.087 40.2033C86.087 40.2033 86.4767 40.2033 86.5958 39.7629ZM80.9603 38.8984C80.9603 39.3901 81.266 40.2371 82.3012 40.2371C83.2009 40.2371 83.6257 39.5928 83.7949 39.1862V36.6614C81.8262 37.1356 80.9603 37.8813 80.9603 38.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9129 38.762C93.7262 39.609 92.8603 40.9989 90.7725 40.9989C88.8714 40.9989 87.0719 39.44 87.0719 36.9491C87.0719 34.8647 88.5995 32.8643 91.1973 32.8643C92.8614 32.8643 93.3702 33.6274 93.5231 33.8977C93.6585 34.1354 93.6923 34.4569 93.5395 34.7284C93.3189 35.0838 92.8101 35.2376 92.453 35.0162C92.062 34.796 91.943 34.3043 92.1647 33.949C92.2838 33.7462 92.4705 33.6099 92.6397 33.5936C92.7926 33.5598 92.3339 33.0856 91.1973 33.0856C90.5181 33.0856 88.6509 33.5936 88.6509 36.7627C88.6509 39.0171 89.9241 39.9492 91.1296 40.0669C92.369 40.1682 93.4216 39.3725 93.7273 38.6769L93.9141 38.762H93.9129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2062 40.8471H94.354V40.6269C94.9994 40.4405 95.0332 40.1527 95.0332 39.2882V29.9838C95.0332 29.3908 94.8804 29.1531 94.1837 29.0179V28.7977L96.5258 28.3398V39.2882C96.5258 40.2203 96.611 40.4743 97.205 40.6269V40.8471H97.2062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.387 38.847C104.2 39.6439 103.266 40.9989 101.263 40.9989C99.1411 40.9989 97.6298 39.2362 97.6298 36.9992C97.6298 34.4907 99.2251 32.8643 101.33 32.8643C103.299 32.8643 104.658 34.1179 104.658 36.779H99.2251C99.2928 39.0672 100.312 39.9818 101.653 40.1181C102.671 40.2195 103.877 39.5927 104.181 38.762L104.384 38.847H104.387ZM103.199 36.5588C103.199 34.0841 102.096 33.0845 101.28 33.0845C100.313 33.0845 99.2263 34.4232 99.2263 36.5588H103.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 32.8782H107.238V34.7027H106.422V32.8782H104.66V32.0638H106.422V30.2393H107.238V32.0638H109V32.8782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6863 27.9092H36.3385V35.177H36.6863C39.0425 35.177 40.9727 35.1199 40.9727 31.5536C40.9727 27.9872 38.9456 27.9103 36.6863 27.9103V27.9092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0768 31.5524C43.0768 34.9638 40.5281 35.4263 36.6851 35.4263H36.3374V38.5872C36.3374 40.0634 36.621 40.6285 37.1414 40.844H48.9516L43.2134 30.9209L42.9835 30.5225C43.0442 30.8324 43.0768 31.1726 43.0768 31.5501V31.5524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.427 38.6466V29.722C34.427 28.5313 34.2087 28.0209 33.4712 27.9277L31.7382 30.9244L26 40.8451H33.8026C34.2554 40.5981 34.427 39.9701 34.427 38.6454V38.6466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6863 27.6585H41.3275L37.4764 21L33.6264 27.6585H36.6863Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10322_10129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint38_linear_10322_10129)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 148,
    width: 48,
    height: 28,
    rx: 14,
    fill: "url(#paint39_linear_10322_10129)"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6979 166.9C51.3941 166.596 51.3941 166.106 51.6979 165.803L54.7124 162.777H42.8958C42.4674 162.777 42.1168 162.427 42.1168 162C42.1168 161.572 42.4674 161.222 42.8958 161.222H54.7124L51.6901 158.204C51.3863 157.901 51.3863 157.411 51.6901 157.107C51.9939 156.804 52.4846 156.804 52.7884 157.107L57.1505 161.455C57.4543 161.758 57.4543 162.248 57.1505 162.552L52.7962 166.9C52.4924 167.195 51.9939 167.195 51.6979 166.9Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10322_10129",
    x: 0,
    y: 0,
    width: 386,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_10129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_10129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10322_10129",
    x: 18,
    y: 140,
    width: 64,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_10129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_10129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10322_10129",
    x1: 269.061,
    y1: 67.207,
    x2: 269.061,
    y2: 174.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10322_10129",
    x1: 269.061,
    y1: 159.895,
    x2: 269.061,
    y2: 191.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10322_10129",
    x1: 269.061,
    y1: 69.374,
    x2: 269.061,
    y2: 157.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10322_10129",
    x1: 269.061,
    y1: 195.396,
    x2: 269.061,
    y2: 169.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10322_10129",
    x1: 330.625,
    y1: 171.493,
    x2: 330.625,
    y2: 164.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10322_10129",
    x1: 303.819,
    y1: 75.2833,
    x2: 303.819,
    y2: 86.5654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10322_10129",
    x1: 283,
    y1: 84.3305,
    x2: 283,
    y2: 98.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10322_10129",
    x1: 283.024,
    y1: 97.1429,
    x2: 283.024,
    y2: 111.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10322_10129",
    x1: 283,
    y1: 110.338,
    x2: 283,
    y2: 124.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10322_10129",
    x1: 283,
    y1: 123.338,
    x2: 283,
    y2: 137.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#566AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4953AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10322_10129",
    x1: 238.818,
    y1: 75.6769,
    x2: 238.818,
    y2: 86.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10322_10129",
    x1: 218,
    y1: 84.3305,
    x2: 218,
    y2: 98.8541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#C5DF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ADC74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BF49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10322_10129",
    x1: 218.024,
    y1: 97.1429,
    x2: 218.024,
    y2: 111.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10322_10129",
    x1: 218,
    y1: 110.338,
    x2: 218,
    y2: 124.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10322_10129",
    x1: 298.06,
    y1: 178.669,
    x2: 298.129,
    y2: 202.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10322_10129",
    x1: 288.355,
    y1: 178.613,
    x2: 288.424,
    y2: 201.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#71C6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4AA1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10322_10129",
    x1: 289.643,
    y1: 150.946,
    x2: 289.643,
    y2: 186.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10322_10129",
    x1: 373.927,
    y1: 112.533,
    x2: 373.927,
    y2: 130.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10322_10129",
    x1: 371.922,
    y1: 110.367,
    x2: 371.922,
    y2: 132.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10322_10129",
    x1: 336.044,
    y1: 134.767,
    x2: 336.044,
    y2: 185.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10322_10129",
    x1: 319.066,
    y1: 163.798,
    x2: 308.648,
    y2: 149.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F99E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3875F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10322_10129",
    x1: 287.77,
    y1: 146.13,
    x2: 287.535,
    y2: 225.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10322_10129",
    x1: 379.794,
    y1: 146.082,
    x2: 379.794,
    y2: 224.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10322_10129",
    x1: 343.419,
    y1: 93.1129,
    x2: 343.419,
    y2: 161.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10322_10129",
    x1: 356.345,
    y1: 150.417,
    x2: 356.345,
    y2: 137.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10322_10129",
    x1: 360.405,
    y1: 93.1125,
    x2: 360.405,
    y2: 161.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10322_10129",
    x1: 356.444,
    y1: 146.083,
    x2: 356.444,
    y2: 224.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10322_10129",
    x1: 357.157,
    y1: 151.525,
    x2: 357.157,
    y2: 132.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDAC7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FA9E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F4885F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10322_10129",
    x1: 328.554,
    y1: 146.083,
    x2: 328.554,
    y2: 224.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10322_10129",
    x1: 357.902,
    y1: 93.1125,
    x2: 357.902,
    y2: 161.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E5141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#864235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A271F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10322_10129",
    x1: 357.173,
    y1: 94.4523,
    x2: 357.173,
    y2: 115.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10322_10129",
    x1: 338.961,
    y1: 110.317,
    x2: 338.961,
    y2: 132.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10322_10129",
    x1: 336.906,
    y1: 112.533,
    x2: 336.906,
    y2: 130.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9CBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D5C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C9BBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDB0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10322_10129",
    x1: 378.866,
    y1: 225.288,
    x2: 378.866,
    y2: 141.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10322_10129",
    x1: 382.628,
    y1: 225.288,
    x2: 382.628,
    y2: 141.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3C2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#403131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10322_10129",
    x1: 210.794,
    y1: 184.727,
    x2: 210.794,
    y2: 200.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10322_10129",
    x1: 207.878,
    y1: 167.985,
    x2: 207.878,
    y2: 178.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10322_10129",
    x1: 210.761,
    y1: 178.655,
    x2: 210.761,
    y2: 185.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10322_10129",
    x1: 74,
    y1: 176,
    x2: 23.5788,
    y2: 170.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10322_10129",
    x1: 50,
    y1: 108.042,
    x2: 50,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_10129"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 382,
    height: 194,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10322_10129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 20,
    fill: "white",
    transform: "translate(26 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTas);
export default __webpack_public_path__ + "static/media/TAS.9b4f4ca60c3a3da3ef4a0703388b1b1a.svg";
export { ForwardRef as ReactComponent };